// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9ffe3c06","239":"05293651","453":"518e6b28","455":"236dab50"}[chunkId] + ".chunk.js";
};